import { atom } from "jotai";

// True while GET /payments/card-surcharge is in flight (#297). The quote itself stays
// in Checkout's state — it is per-amount, per-method view data, not app-global truth.
export const isFetchingSurchargeQuoteAtom = atom<boolean>(false);
